import { OverlayToaster, Position } from '@blueprintjs/core';

export const AppToaster = OverlayToaster.create({
  position: Position.BOTTOM_LEFT,
});
